import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import { client } from "@/hono";
import { useCitadel } from "@/hooks/use-citadel";

export function useCurrentPlan() {
	/** Hooks */
	const { citadel } = useCitadel();

	/** Query */
	const query = useQuery({
		queryKey: ["plan", "current"],
		queryFn: async () => {
			const response = await client.plan.current.$get();
			const data = await responseHandler(response);
			return data;
		},
		staleTime: 1_000 * 60 * 10,
		refetchInterval: 1_000 * 60,
		refetchOnWindowFocus: true,
		// The endpoint gates on `read Plan`, which the base set holds but a role may narrow away.
		// The command screen is reachable without it, so the request is not sent rather than
		// answered with a refusal and a toast every minute the interval fires.
		enabled: citadel?.can("read", "Plan", { orgId: citadel.orgId }) === true,
	});

	/** Return */
	return { ...query, plans: guardArray(query.data?.plan?.plans), date: query?.data?.plan?.date };
}
